(() => {
  if (window.acContentReady) return;
  window.acContentReady = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ac-columns]');
    if (!button) return;
    const collection = button.closest('.ac-collection');
    if (!collection) return;
    collection.dataset.acMobileColumns = button.dataset.acColumns;
    collection.querySelectorAll('[data-ac-columns]').forEach(control => {
      control.setAttribute('aria-pressed', String(control === button));
    });
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-ac-sort]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });
})();
// Keep source-style filter groups inline while Dawn handles the outer drawer and AJAX.
document.addEventListener('click', (event) => {
  const summary = event.target.closest('.ac-collection .mobile-facets__details.ac-filter-group > summary');
  if (summary) {
    event.stopImmediatePropagation();
    return; // Native details toggle; bypass Dawn's nested submenu/focus trap.
  }
  const opener = event.target.closest('.ac-collection .mobile-facets__open-wrapper');
  if (opener && !opener.parentElement.open) {
    opener.closest('menu-drawer').querySelectorAll('.ac-filter-group').forEach(group => group.open = true);
  }
}, true);
document.addEventListener('keyup', (event) => {
  if (event.key !== 'Escape') return;
  const drawer = event.target.closest('.ac-collection menu-drawer');
  if (!drawer || !drawer.querySelector('details').open) return;
  event.stopImmediatePropagation();
  drawer.querySelector('.mobile-facets__open-wrapper').click();
}, true);
document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-ac-desktop-columns]');
  if (!control) return;
  const collection = control.closest('.ac-collection');
  collection.dataset.acDesktopColumns = control.dataset.acDesktopColumns;
  collection.querySelectorAll('[data-ac-desktop-columns]').forEach(button => button.setAttribute('aria-pressed', String(button === control)));
});
